export const SUBSCRIPTION_FIELDS = `
    id
    cost
    duration
    currency
`;
